import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import GeneralPsychiatry from "@/pages/GeneralPsychiatry";
import Neuropsychiatry from "@/pages/Neuropsychiatry";
import ForPhysicians from "@/pages/ForPhysicians";
import NeuropsychiatryGu from "@/pages/NeuropsychiatryGu";
import GeneralPsychiatryGu from "@/pages/GeneralPsychiatryGu";
import DeaddictionGu from "@/pages/DeaddictionGu";
import SexologyGu from "@/pages/SexologyGu";
import NeuromodulationGu from "@/pages/NeuromodulationGu";
import ConditionPage from "@/pages/ConditionPage";
import TherapyPage from "@/pages/TherapyPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Deaddiction from "@/pages/Deaddiction";
import Neuromodulation from "@/pages/Neuromodulation";
import Sexology from "@/pages/Sexology";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import DoctorDetail from "@/pages/DoctorDetail";
import CaseReports from "@/pages/CaseReports";
import CaseReportDetail from "@/pages/CaseReportDetail";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/general-psychiatry" element={<Layout><GeneralPsychiatry /></Layout>} />
        <Route path="/for-physicians" element={<Layout><ForPhysicians /></Layout>} />
        <Route path="/neuropsychiatry" element={<Layout><Neuropsychiatry /></Layout>} />
        <Route path="/gu/neuropsychiatry" element={<Layout><NeuropsychiatryGu /></Layout>} />
        <Route path="/gu/general-psychiatry" element={<Layout><GeneralPsychiatryGu /></Layout>} />
        <Route path="/gu/deaddiction" element={<Layout><DeaddictionGu /></Layout>} />
        <Route path="/gu/sexology" element={<Layout><SexologyGu /></Layout>} />
        <Route path="/gu/neuromodulation" element={<Layout><NeuromodulationGu /></Layout>} />
        <Route path="/conditions/:slug" element={<Layout><ConditionPage /></Layout>} />
        <Route path="/therapies/:slug" element={<Layout><TherapyPage /></Layout>} />
        <Route path="/blog" element={<Layout><Blog /></Layout>} />
        <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
        <Route path="/deaddiction" element={<Layout><Deaddiction /></Layout>} />
        <Route path="/neuromodulation" element={<Layout><Neuromodulation /></Layout>} />
        <Route path="/sexology" element={<Layout><Sexology /></Layout>} />
        <Route path="/case-reports" element={<Layout><CaseReports /></Layout>} />
        <Route path="/case-reports/:slug" element={<Layout><CaseReportDetail /></Layout>} />
        <Route path="/articles" element={<Layout><Articles /></Layout>} />
        <Route path="/articles/:slug" element={<Layout><ArticleDetail /></Layout>} />
        <Route path="/faq" element={<Layout><FAQ /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/doctors/:slug" element={<Layout><DoctorDetail /></Layout>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </>
  );
}
